$(function() {
  //ヘッダーの高さを取得
  var headerHeight = $('.site-header').outerHeight();

  var imgSrc = $('.site-header__logo-image').children('img').attr('src').replace('ASA_logo','logo-w');

  // var btnText = $('.product-form__cart-submit').text('発売前');

  $(window).scroll(function() {
    //スクロール量の取得
    var scroll = $(this).scrollTop();

    //スクロール量がヘッダーを超えたら
    if(headerHeight <= scroll) {
      $('.js-header').css('transform','translateY(60px)');
      $('.js-header').addClass('header-fixed');
      $('.js-header').removeClass('header_top ');
      $('.site-header__mobile-nav').css('background','#8d8d8d');
      $('.site-header').css('background','#8d8d8d');
      $('.site-header__icon').children('svg').css('color','#fff');
      $('.site-header__logo-image').children('img').attr('src','https://cdn.shopify.com/s/files/1/0553/8378/5670/files/logo-w.png?v=1618533784');
      $('.site-header__logo-image').children('img').attr('srcset','https://cdn.shopify.com/s/files/1/0553/8378/5670/files/logo-w.png?v=1618533784');
      $('.header-logo').css('display','none');
    } else {
      $('.js-header').removeClass('header-fixed');
      $('.js-header').addClass('header_top');
      $('.js-header').css('transform','translateY(0px)');
      $('.site-header__mobile-nav').css('background','#fff');
      $('.site-header').css('background','#fff');
      $('.site-header__icon').children('svg').css('color','#000');
      $('.site-header__logo-image').children('img').attr('src','https://cdn.shopify.com/s/files/1/0553/8378/5670/files/ASA_logo.jpg?v=1616396745');
      $('.site-header__logo-image').children('img').attr('srcset','https://cdn.shopify.com/s/files/1/0553/8378/5670/files/ASA_logo.jpg?v=1616396745');
      $('.header-logo').css('display','block');
    }
  })
})